import signalsPlugin from '@backstage/plugin-signals/alpha';
import catalogUnprocessedEntitiesPlugin from '@backstage/plugin-catalog-unprocessed-entities/alpha';

export const plugins = [signalsPlugin, catalogUnprocessedEntitiesPlugin];
